import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import { EstimateTable } from "../components/EstimateTable";

export function AllEstimates() {
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [search, setSearch] = useState("");
  const params: Record<string, string> = {};
  if (status) params.status = status;
  if (type)   params.type = type;
  if (search) params.q = search;
  const list = useQuery({ queryKey: ["all", status, type, search], queryFn: () => api.allEstimates(params) });

  return (
    <div className="space-y-6">
      <div className="flex items-baseline justify-between flex-wrap gap-2">
        <div>
          <h1 className="text-3xl font-semibold text-liaise-navy">All estimates</h1>
          <p className="text-slate-500 mt-1">Cross-organisation oversight.</p>
        </div>
        <button onClick={() => api.downloadAllEstimatesCsv()}
          className="px-3 py-2 rounded-lg bg-white border border-slate-200 text-sm hover:bg-slate-50">
          ↓ Export CSV
        </button>
      </div>

      <div className="flex gap-3 flex-wrap">
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="px-3 py-2 border border-slate-200 rounded text-sm bg-white">
          <option value="">All statuses</option>
          {["draft", "submitted", "approved", "rejected", "recalled"].map((s) => <option key={s}>{s}</option>)}
        </select>
        <select value={type} onChange={(e) => setType(e.target.value)} className="px-3 py-2 border border-slate-200 rounded text-sm bg-white">
          <option value="">All types</option>
          <option value="holiday">Holiday</option>
          <option value="hospital">Hospital</option>
          <option value="transition">Transition</option>
          <option value="case">Case-by-case</option>
          <option value="uplift">Uplift</option>
          <option value="awf">AWF</option>
        </select>
        <input
          placeholder="Search ref / claimant / PWS..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="px-3 py-2 border border-slate-200 rounded text-sm flex-1 bg-white min-w-[200px]"
        />
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        {list.isLoading && <div className="p-6 text-slate-500 text-sm">Loading...</div>}
        {list.data && <EstimateTable rows={list.data.estimates ?? []} />}
      </div>
    </div>
  );
}
